import { all, fork, select, setContext, take } from 'redux-saga/effects';
import { reduxInitialized } from '../actions/initialization';
import { getPublicSession } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { createClient } from '@supabase/supabase-js';
import { authSaga } from './auth';
import { counterSaga } from './counter';
import { drawerSaga } from './drawer';
import { roomSaga } from './room';
import { globalSaga } from './global';
import { draftsSaga } from './drafts';
/**
 * Storybook doesn't like redux modules, so we split the saga into two parts:
 * 1. This function that has all the saga functionality. We'd use this in storybook.
 * 2. {@link rootSaga} that gates saga execution behind the {@link reduxInitialized} action. We'd use that one
 *    in our apps.
 */ function* modulelessRootSaga() {
    // Create the client and set it in saga context for use in sub-sagas
    const session = yield select(getPublicSession);
    const damzConfig = session.damz;
    var _damzConfig_endpoint, _damzConfig_anonToken;
    const supaClient = createClient((_damzConfig_endpoint = damzConfig === null || damzConfig === void 0 ? void 0 : damzConfig.endpoint) !== null && _damzConfig_endpoint !== void 0 ? _damzConfig_endpoint : '', (_damzConfig_anonToken = damzConfig === null || damzConfig === void 0 ? void 0 : damzConfig.anonToken) !== null && _damzConfig_anonToken !== void 0 ? _damzConfig_anonToken : '', {
        db: {
            schema: 'damz'
        }
    });
    yield setContext({
        supaClient,
        damzConfig
    });
    yield all([
        fork(authSaga),
        fork(counterSaga),
        fork(globalSaga),
        fork(drawerSaga),
        fork(roomSaga),
        fork(draftsSaga)
    ]);
}
export default function* rootSaga() {
    yield take(reduxInitialized);
    yield modulelessRootSaga();
}

//# sourceMappingURL=index.js.map